import React from 'react'
import {CloseIconContainer} from './style';
import { useSelector } from 'react-redux'
import {RootState} from '../../redux/reducers/index'
import config from "../../config/enviroment";
import "external-svg-loader";

const CloseIcon = ({closeAction}: any) => {

    const homeState: HomeStateType = useSelector((state: RootState) => state.home)

    return (        
            <CloseIconContainer onClick={closeAction} color={homeState.color}>                
                <svg data-src={`${config.urlMultimedia}/vende/landing-img/CloseIcon.svg`}/>
            </CloseIconContainer>

    )
}

export default CloseIcon